import { getPostHogInstance } from '@repo/shared-utils';
import type { UserRole } from '@repo/shared-types';

export const ONBOARDING_ANALYTICS = {
  STEP_VIEWED: 'onboarding_step_viewed',
  STEP_VALIDATION_FAILED: 'onboarding_step_validation_failed',
  STEP_COMPLETED: 'onboarding_step_completed',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  ONBOARDING_ABANDONED: 'onboarding_abandoned',
  /** Clerk session token not ready within wait budget (complete-onboarding). */
  CLERK_TOKEN_WAIT_EXHAUSTED: 'onboarding_clerk_token_wait_exhausted',
} as const;

export type OnboardingFlowKind = 'embedded' | 'standalone';

export function captureOnboardingEvent(
  name: (typeof ONBOARDING_ANALYTICS)[keyof typeof ONBOARDING_ANALYTICS],
  payload: {
    role: UserRole | string;
    flow: OnboardingFlowKind;
    stepId: string;
    stepIndex: number;
    errorCode?: string;
    errorField?: string;
    /** Additional PostHog dimensions (flat object). */
    extra?: Record<string, unknown>;
  },
): void {
  const ph = getPostHogInstance();
  ph?.capture?.(name, {
    role: payload.role,
    flow: payload.flow,
    step_id: payload.stepId,
    step_index: payload.stepIndex,
    ...(payload.errorCode ? { error_code: payload.errorCode } : {}),
    ...(payload.errorField ? { error_field: payload.errorField } : {}),
    ...(payload.extra && typeof payload.extra === 'object' ? payload.extra : {}),
  });
}
